if ($(window).width() >= 1200) {
} else {
  $(".parent-sub").click(function (e) {
    var $target = $(e.target);
    if ($target.closest(".sub-menu").length && $target.closest("a").length) {
      return;
    }

    e.preventDefault();

    var $clickedParent = $(this);
    var $clickedSubmenu = $clickedParent.find(".sub-menu").first();
    var isAlreadyActive = $clickedParent.hasClass("menu-active");

    $(".parent-sub.menu-active")
      .not($clickedParent)
      .each(function () {
        var $openParent = $(this);
        var $openSub = $openParent.find(".sub-menu").first();
        $openParent.removeClass("menu-active");
        $openSub.removeClass("show-sub-menu is-closing").css("max-height", "");
      });

    if (isAlreadyActive) {
      $clickedParent.removeClass("menu-active");
      $clickedSubmenu
        .removeClass("show-sub-menu is-closing")
        .css("max-height", "");
    } else {
      $clickedParent.addClass("menu-active");
      $clickedSubmenu.addClass("show-sub-menu");
      $clickedSubmenu.css("max-height", $clickedSubmenu[0].scrollHeight + "px");
    }

    $clickedParent.find(".sub-sub-menu").removeClass("sub-active");
  });
}

$('a[href="#"]').on("click", function (e) {
  e.preventDefault();
});

//removes dropdown menu active class when clicking outside of element
$("body").on("click", function (e) {
  var dropdownMenu = $(".show-sub-menu,.parent-sub,.search");
  if (dropdownMenu !== event.target && !dropdownMenu.has(event.target).length) {
    $(".parent-sub").removeClass("menu-active");
    $(".parent-sub").removeClass("active-page");
    $(".sub-menu").removeClass("show-sub-menu");
    $(".sub-sub-menu").removeClass("sub-active");
    $(".js-show").removeClass("show-sub-sub");
    $(".search").removeClass("show-form");
  }
});

(function ($) {
  $("#navbarToggle").on("click", function () {
    var primaryNavigation = $(".site-navigation");
    $this = $(this);

    if (primaryNavigation.hasClass("mobile-show")) {
      primaryNavigation.removeClass("mobile-show");
      $("body").removeClass("no-scroll");
      $this.addClass("collapsed");
      $this.attr("aria-expanded", "false");
      $("#searchFormWrapper").attr("inert", "").attr("aria-hidden", "true");
    } else {
      primaryNavigation.addClass("mobile-show");
      $("body").addClass("no-scroll");
      $this.removeClass("collapsed");
      $this.attr("aria-expanded", "true");
      $("#searchFormWrapper").removeAttr("inert").attr("aria-hidden", "false");
    }
  });

  $(window).on("resize", function () {
    if ($(window).width() >= 1200) {
      $(".site-navigation").removeClass("mobile-show");
      $("body").removeClass("no-scroll");
      $("#navbarToggle").addClass("collapsed");
      $("#navbarToggle").attr("aria-expanded", "false");
      $("#searchFormWrapper").attr("inert", "").attr("aria-hidden", "true");
    }
  });
})(jQuery);

function openAndAdjustActiveSubmenus() {
  if ($(window).width() >= 1200) {
    $(
      ".parent-sub.active-page .sub-menu, .parent-sub.menu-active .sub-menu",
    ).each(function () {
      var $submenu = $(this);
      if (!$submenu.hasClass("show-sub-menu")) {
        $submenu.addClass("show-sub-menu");
      }
      adjustSubmenuPosition($submenu);
    });
  }
}

$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    if ($(".sub-menu").hasClass("show-sub-menu")) {
      $(".sub-menu").removeClass("show-sub-menu");
      $(".parent-sub").removeClass("menu-active");
      $(".parent-sub").removeClass("active-page");
    }
  }
});

$(window).on("load resize", function () {});

$(document).ready(function () {
  function adjustSubmenuPosition($submenu) {
    if ($(window).width() >= 1200) {
      const $container = $(".header-bottom-row");
      const defaultOffset = -11;
      $submenu.css("transform", `translateX(${defaultOffset}%)`);

      const submenuRect = $submenu[0].getBoundingClientRect();
      const containerRect = $container.length
        ? $container[0].getBoundingClientRect()
        : { left: 0, right: $(window).width() };

      const edgePadding = 20;

      const overflowLeft = containerRect.left + edgePadding - submenuRect.left;
      const overflowRight =
        submenuRect.right - (containerRect.right - edgePadding);

      let additionalShiftPx = 0;
      if (overflowLeft > 0) {
        additionalShiftPx += overflowLeft;
      }
      if (overflowRight > 0) {
        additionalShiftPx -= overflowRight;
      }

      if (additionalShiftPx !== 0) {
        const baseShiftPx = (defaultOffset / 100) * submenuRect.width;
        const totalShiftPx = baseShiftPx + additionalShiftPx;
        $submenu.css("transform", `translateX(${totalShiftPx}px)`);
      }
    } else {
      $submenu.css("transform", "");
    }
  }

  if ($(window).width() >= 1200) {
    $(".parent-sub > .dropdown-arrow > a").on("click", function (e) {
      const $parentLi = $(this).closest(".parent-sub");

      if ($parentLi.hasClass("menu-active")) {
        $parentLi.removeClass("menu-active active-page");
        $parentLi.find(".sub-menu").removeClass("show-sub-menu");
      } else {
        $(".parent-sub").removeClass("menu-active active-page");
        $(".sub-menu").removeClass("show-sub-menu");

        $parentLi.addClass("menu-active active-page");
        const $submenu = $parentLi.find(".sub-menu");
        $submenu.addClass("show-sub-menu");

        adjustSubmenuPosition($submenu);
      }

      e.preventDefault();
    });

    $(".parent-sub > .dropdown-arrow > a").on("keydown", function (e) {
      const $parentLi = $(this).closest(".parent-sub");
      const $submenu = $parentLi.find(".sub-menu");

      // Enter key opens/closes dropdown and focuses first submenu item
      if (e.keyCode === 13) {
        e.preventDefault();

        if (!$parentLi.hasClass("menu-active")) {
          // Close all other dropdowns
          $(".parent-sub").removeClass("menu-active active-page");
          $(".sub-menu").removeClass("show-sub-menu");

          // Open this dropdown
          $parentLi.addClass("menu-active active-page");
          $submenu.addClass("show-sub-menu");
          adjustSubmenuPosition($submenu);

          // Focus first link in submenu
          const $firstLink = $submenu.find("a").first();
          if ($firstLink.length) {
            $firstLink.focus();
          }
        } else {
          // Close dropdown if already open
          $parentLi.removeClass("menu-active active-page");
          $submenu.removeClass("show-sub-menu");
        }
      }
    });

    $(".sub-menu a").on("keydown", function (e) {
      const $parentLi = $(this).closest(".parent-sub");
      const $submenu = $(this).closest(".sub-menu");
      const $allLinks = $submenu.find("a");
      const currentIndex = $allLinks.index(this);

      if (e.keyCode === 27) {
        e.preventDefault();

        $parentLi.removeClass("menu-active active-page");
        $submenu.removeClass("show-sub-menu");

        const $parentLink = $parentLi.find("> .dropdown-arrow > a");
        const $allNavItems = $("#primaryNavigation")
          .find("a, button")
          .filter(":visible");
        const parentIndex = $allNavItems.index($parentLink);

        if (parentIndex !== -1 && parentIndex < $allNavItems.length - 1) {
          $allNavItems.eq(parentIndex + 1).focus();
        } else {
          $parentLink.focus();
        }
      }

      if (e.keyCode === 9 && !e.shiftKey) {
        e.preventDefault();

        if (currentIndex < $allLinks.length - 1) {
          $allLinks.eq(currentIndex + 1).focus();
        } else {
          $allLinks.eq(0).focus();
        }
      }

      if (e.keyCode === 9 && e.shiftKey) {
        e.preventDefault();

        if (currentIndex > 0) {
          $allLinks.eq(currentIndex - 1).focus();
        } else {
          $allLinks.eq($allLinks.length - 1).focus();
        }
      }
    });

    openAndAdjustActiveSubmenus();

    $(".sub-menu.show-sub-menu").each(function () {
      adjustSubmenuPosition($(this));
    });
  }

  let resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ($(window).width() >= 1200) {
        $(".sub-menu.show-sub-menu").each(function () {
          adjustSubmenuPosition($(this));
        });
        openAndAdjustActiveSubmenus();
      } else {
        $(".sub-menu").css("transform", "");
      }
    }, 250);
  });

  $(window).on("load", function () {
    if ($(window).width() >= 1200) {
      $(".sub-menu.show-sub-menu").each(function () {
        adjustSubmenuPosition($(this));
      });
      openAndAdjustActiveSubmenus();
    }
  });
});

// Search toggle
(function ($) {
  var $nav = $(".site-navigation");
  var $toggle = $("#searchToggle");
  var $close = $("#searchClose");
  var $input = $("#nav-search-input");

  function syncCloseButton() {
    $close.toggleClass("is-visible", $input.val().length > 0);
  }

  function openSearch() {
    var toggleEl = $toggle[0];
    var beforeRect = toggleEl.getBoundingClientRect();

    $nav.addClass("search-open");
    syncCloseButton();
    $toggle.attr("aria-expanded", "true");
    $("#searchFormWrapper").removeAttr("inert").attr("aria-hidden", "false");

    var afterRect = toggleEl.getBoundingClientRect();
    var deltaX = beforeRect.left - afterRect.left;

    $toggle.css("transition", "none");
    $toggle.css("transform", "translateX(" + deltaX + "px)");
    toggleEl.offsetHeight;
    $toggle.css("transition", "");
    $toggle.css("transform", "");

    setTimeout(function () {
      $input.focus();
    }, 400);
  }

  function closeSearch() {
    $toggle.css("transition", "none");
    $toggle.css("opacity", "0");

    $nav.addClass("search-closing");
    $toggle.attr("aria-expanded", "false");
    $("#searchFormWrapper").attr("inert", "").attr("aria-hidden", "true");

    setTimeout(function () {
      $nav.removeClass("search-open search-closing");
      $toggle[0].offsetHeight;
      $toggle.css("transition", "");
      $toggle.css("opacity", "");

      setTimeout(function () {
        $toggle.focus();
      }, 10);
    }, 400);
  }

  $toggle.on("click", function (e) {
    e.stopPropagation();
    if ($(window).width() < 1200 || $nav.hasClass("search-open")) {
      $(".nav-search__form")[0].requestSubmit();
    } else {
      openSearch();
    }
  });

  $close.on("click", function (e) {
    e.stopPropagation();
    $input.val("").focus();
    $close.removeClass("is-visible");
  });

  $input.on("input", syncCloseButton);

  $(document).on("keyup.search", function (e) {
    if (e.keyCode === 27 && $nav.hasClass("search-open")) {
      closeSearch();
    }
  });

  $("body").on("click.search", function (e) {
    if (
      $nav.hasClass("search-open") &&
      !$(e.target).closest(".nav-search").length
    ) {
      closeSearch();
    }
  });

  $(window).on("resize.search", function () {
    if ($(window).width() >= 1200) {
      $nav.removeClass("search-open");
    }
  });

  $(document).ready(syncCloseButton);
})(jQuery);
